import isEmpty from "../helpers/isEmpty";

class TagModel {
  constructor(data) {
    this.id = data.id || "";
    this.title = data.title || "";
    this.key = data.key || "";
  }

  static displayTags(tags) {
    return !isEmpty(tags) && Array.isArray(tags)
      ? `<span class="social-options__buttons">
          <div class="tag-buttons">
            ${tags.map((tag) =>
              tag instanceof TagModel && tag.title ? tag.displayTag(tag) : ""
            )}
          </div>
        </span>`
      : "";
  }

  displayTag(tag) {
    return `<span data-tag-key="${tag.key}">${tag.title}</span>`;
  }
}

export default TagModel;
